export const colors = {
  // Background colors
  background: '#000000', // Black main background
  backgroundMuted: '#1a1a1a', // Dark muted background for cards
  contactFormBackground: '#000000', // Black background for form inputs
  telephoneIconColor: '#C7B299', // Beige/brown for telephone icon
  darkBrown: '#332200', // Dark brown-black for icon outlines (#332200 or #212121)
  
  // ===========================================
  // לוח צבעים מתוחכם - גוונים של זהב-כתום
  // ===========================================
  // Base Color: #F5B658 (RGB: 245, 182, 88)
  
  // Gold-Orange Shades - גוונים שונים של זהב-כתום
  gold: {
    // כהה מאוד - לכותרות גדולות, טקסט חשוב מאוד
    dark: '#B8822E', // כהה יותר - עומק
    darker: '#D4943A', // כהה - כותרות ראשיות
    
    // בינוני-כהה - לכותרות משניות, טקסט חשוב
    mediumDark: '#E8A84F', // בינוני-כהה - כותרות משניות
    
    // בסיס - אקסנטים בינוניים, טקסט רגיל
    base: '#F5B658', // צבע בסיס - אקסנטים
    
    // בינוני-בהיר - לכפתורים, CTA
    mediumLight: '#FCC87A', // בינוני-בהיר - כפתורים
    
    // בהיר - להדגשות עדינות, hover effects
    light: '#FFD899', // בהיר - הדגשות
    lighter: '#FFE5B4', // בהיר מאוד - רקעים עדינים
  },
  
  // Legacy support - שמירה על תאימות לאחור
  orange: '#F5B658', // Base color for backward compatibility
  orangeGold: '#F5B658', // Base color
  goldPrimary: '#E8A84F', // Medium dark for headings
  goldSecondary: '#F5B658', // Base for accents
  goldAccent: '#FCC87A', // Light for buttons
  goldText: '#D4943A', // Dark for important text
  
  // Header & Section Backgrounds - גוונים עדינים יותר
  headerBackground: '#B8822E', // כהה - רקע עדין
  headerBackgroundLight: 'rgba(184, 130, 46, 0.15)', // שקוף
  contactSectionBackground: '#D4943A', // בינוני-כהה
  contactSectionBackgroundLight: 'rgba(212, 148, 58, 0.12)', // שקוף
  
  // Button Colors
  submitButtonOrange: '#FCC87A', // בהיר - לכפתורים בולטים
  buttonPrimary: '#FCC87A', // כפתורים ראשיים
  buttonHover: '#FFD899', // hover על כפתורים
  
  // Text colors
  textPrimary: '#FFFFFF', // White text
  textSecondary: '#B8B8B8', // Light grey (logo tagline) - שופר לניגודיות 5.5:1
  textDark: '#2C2C2C', // Dark brown/black (logo AR, badge text)
  textMuted: '#A89B8F', // Beige-grey - שופר לניגודיות 4.8:1
  
  // Gold Text Variants - גוונים שונים לטקסט זהב
  textGold: {
    dark: '#B8822E', // כהה מאוד - כותרות גדולות
    medium: '#D4943A', // כהה - כותרות משניות
    base: '#F5B658', // בסיס - כותרות רגילות
    light: '#FCC87A', // בהיר - הדגשות
  },
  
  // Form colors
  inputBackground: '#000000', // Black background for form inputs
  inputBorder: '#F5B658', // Base border
  inputBorderFocus: '#FCC87A', // Focus border - בהיר יותר
  
  // Q&A Section colors
  qaActiveBorder: '#F5B658', // Gold border for active Q&A item
  qaCardBackground: '#1a1a1a', // Dark background for Q&A cards
  
  // Other
  cream: '#fffbf4',
  accent: '#F5B658', // Base accent (backward compatibility)
  
  // Overlays & Transparent - רקעים שקופים
  footerOverlay: 'rgba(212, 148, 58, 0.25)', // Medium dark transparent
  headerOverlay: 'rgba(184, 130, 46, 0.85)', // Dark transparent with blur
  backgroundOverlayLight: 'rgba(252, 200, 122, 0.08)', // Light overlay
  
  // Top border
  topBorder: '#D4943A', // Medium dark gold
  
  // ===========================================
  // אקסנט צבעים מיוחדים - זהב-כתום חד ומרשים (כמו סקולו)
  // ===========================================
  // גרדיאנטים חדים ומרשימים - שילוב עם צבעי המכונה (כתום-זהב)
  // מעברים חדים וברורים - לא רכים מדי
  
  // Gold-Orange Accent Colors - גוונים חדים ומרשימים
  accentSpecial: {
    // גרדיאנטים חדים לכפתורים - מעברים ברורים וחדים
    buttonGradient: 'linear-gradient(90deg, #B8822E 0%, #D4943A 25%, #E8A84F 50%, #F5B658 75%, #FCC87A 100%)', // חד - כהה מאוד → כהה → בינוני → בסיס → בהיר
    buttonHoverGradient: 'linear-gradient(90deg, #D4943A 0%, #E8A84F 25%, #F5B658 50%, #FCC87A 75%, #FFD899 100%)', // hover - בהיר יותר
    
    // גרדיאנטים חדים למלל - מעברים ברורים
    textGradient: 'linear-gradient(90deg, #B8822E 0%, #D4943A 30%, #E8A84F 60%, #F5B658 100%)', // חד לטקסט - כהה → בסיס
    textGradientBright: 'linear-gradient(90deg, #D4943A 0%, #E8A84F 35%, #F5B658 70%, #FCC87A 100%)', // בהיר יותר - כהה → בהיר
    textGradientRich: 'linear-gradient(90deg, #B8822E 0%, #D4943A 20%, #E8A84F 40%, #F5B658 60%, #FCC87A 80%, #FFD899 100%)', // עשיר - כל הגוונים
    
    // גרדיאנט חדש עם פסים ברורים - ללא מעברים חלקים!
    textGradientStripes: 'linear-gradient(90deg, #B8822E 0% 16.66%, #D4943A 16.66% 33.33%, #E8A84F 33.33% 50%, #F5B658 50% 66.66%, #FCC87A 66.66% 83.33%, #FFD899 83.33% 100%)', // פסים חדים!
    
    // גרדיאנטים אלכסוניים - מרשימים יותר
    buttonGradientDiagonal: 'linear-gradient(135deg, #B8822E 0%, #D4943A 20%, #E8A84F 40%, #F5B658 60%, #FCC87A 80%, #FFD899 100%)', // אלכסוני לכפתורים
    textGradientDiagonal: 'linear-gradient(135deg, #B8822E 0%, #D4943A 25%, #E8A84F 50%, #F5B658 75%, #FCC87A 100%)', // אלכסוני לטקסט
  },
};

export const typography = {
  // גופנים מקצועיים - Ploni לכותרות, Assistant לטקסט
  fontFamily: "'Assistant', 'Heebo', 'Frank Ruhl Libre', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif", // גופן בסיס לטקסט רגיל - Assistant
  headingFontFamily: "'Ploni', 'Heebo', 'Frank Ruhl Libre', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif", // גופן מקצועי לכותרות - Ploni
  heading: {
    fontFamily: "'Ploni', 'Heebo', 'Frank Ruhl Libre', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif", // Ploni לכותרות - גופן עברי מקצועי מודרני
    lineHeight: 1.2,
    letterSpacing: '0.5px', // רווח אותיות מקצועי
    fontWeight: 700, // משקל בולט לכותרות
  },
  body: {
    fontFamily: "'Assistant', 'Heebo', 'Frank Ruhl Libre', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif", // Assistant לטקסט רגיל
    lineHeight: 1.5, // רווח שורות נוח לקריאה
    letterSpacing: '0.3px', // רווח אותיות עדין לטקסט
    fontWeight: 400, // משקל רגיל לטקסט
  },
  // גדלי טקסט עקביים - הוגדלו ב-15%
  fontSize: {
    xs: '0.875rem',    // 14px (היה 12px)
    sm: '1rem',        // 16px (היה 14px)
    base: '1.15rem',   // 18.4px (היה 16px)
    lg: '1.3rem',      // 20.8px (היה 18px)
    xl: '1.44rem',     // 23px (היה 20px)
    '2xl': '1.75rem',  // 28px (היה 24px)
    '3xl': '2.3rem',   // 36.8px (היה 32px)
    '4xl': '2.9rem',   // 46.4px (היה 40px)
    '5xl': '3.45rem',  // 55.2px (היה 48px)
    '6xl': '4.6rem',   // 73.6px (היה 64px)
    '7xl': '5.75rem',  // 92px (היה 80px)
  },
};

export const layout = {
  contentMaxWidth: '1920px',
  ribbonHeight: '182px',
  sectionSpacing: {
    desktop: '40px',
    tablet: '32px',
    mobile: '24px',
  },
  // Breakpoints
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1280px',
  },
  // ריווחים עקביים
  spacing: {
    xs: '8px',
    sm: '16px',
    md: '24px',
    lg: '32px',
    xl: '48px',
    xxl: '64px',
  },
  // ריווחים בין אלמנטים
  gap: {
    small: '16px',
    md: '24px',
    medium: '24px',
    large: '32px',
    xl: '48px',
    xlarge: '48px',
    xxl: '64px',
  },
  // גדלים עקביים
  sizes: {
    icon: {
      small: '24px',
      medium: '40px',
      large: '60px',
      xlarge: '96px',
    },
    card: {
      width: '380px',
      minHeight: '280px',
    },
    circle: {
      small: '40px',
      medium: '60px',
      large: '140px',
    },
  },
};

export const borderRadius = {
  pill: '80px',
  card: '44px',
  soft: '24px',
};

export const shadows = {
  // Gold shadows - גוונים שונים לצללים
  softGold: '0px 10px 30px rgba(212, 148, 58, 0.35)', // Medium dark gold shadow
  softGoldLight: '0px 8px 24px rgba(252, 200, 122, 0.3)', // Light gold shadow
  softGoldDark: '0px 12px 36px rgba(184, 130, 46, 0.4)', // Dark gold shadow
  
  softDark: '0px 20px 40px rgba(0, 0, 0, 0.35)',
  
  // Hover effects - גוונים בהירים יותר
  hoverGold: '0px 20px 40px rgba(252, 200, 122, 0.45)', // Light gold hover
  hoverGoldMedium: '0px 16px 32px rgba(245, 182, 88, 0.4)', // Base gold hover
  hoverDark: '0px 10px 20px rgba(0, 0, 0, 0.5)',
  
  // Glow effects - זוהר בגוונים שונים
  glowGold: '0px 0px 20px rgba(252, 200, 122, 0.5)', // Light glow
  glowGoldMedium: '0px 0px 30px rgba(245, 182, 88, 0.4)', // Medium glow
  glowGoldDark: '0px 0px 40px rgba(212, 148, 58, 0.5)', // Dark glow
};

// אנימציות ותנועות
export const animations = {
  // משכי זמן
  duration: {
    fast: '0.2s',
    normal: '0.3s',
    slow: '0.6s',
    slower: '1s',
  },
  // easing functions
  easing: {
    ease: 'ease',
    easeIn: 'ease-in',
    easeOut: 'ease-out',
    easeInOut: 'ease-in-out',
    smooth: 'cubic-bezier(0.4, 0, 0.2, 1)', // Material Design easing
  },
  // transitions עקביים
  transitions: {
    // צבעים
    color: 'color 0.3s ease, background-color 0.3s ease',
    // גדלים
    transform: 'transform 0.3s ease',
    // כל התכונות
    all: 'all 0.3s ease',
    // חלק יותר
    allSmooth: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  // keyframes (לשימוש ב-CSS)
  keyframes: {
    fadeInUp: `
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `,
    slideInRight: `
      @keyframes slideInRight {
        from {
          opacity: 0;
          transform: translateX(-30px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }
    `,
    scaleIn: `
      @keyframes scaleIn {
        from {
          opacity: 0;
          transform: scale(0.9);
        }
        to {
          opacity: 1;
          transform: scale(1);
        }
      }
    `,
  },
};




